"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Price;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _utilities = require("@sart/utilities");
var _Text = _interopRequireDefault(require("./Text"));
var _excluded = ["code", "value", "currency", "style", "floatFormat"];
function Price(props) {
  var code = props.code,
    value = props.value,
    currency = props.currency,
    style = props.style,
    floatFormat = props.floatFormat,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var priceStyle = value === 0 ? styles.zero : styles["default"];
  var priceStyles = [priceStyle, style];
  var priceObject = (0, _utilities.formatCurrencyToObject)(value, code);
  var priceResult = floatFormat ? priceObject.symbol + priceObject["float"] : priceObject.formated;
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    style: priceStyles
  }, rest), priceResult);
}
var styles = _reactNative.StyleSheet.create({
  "default": {
    // color: colors.feature
  },
  zero: {
    color: _styles.colors.subtle
  }
});
Price.defaultProps = {
  value: 0
};
var PropTypesCurrencyShape = _propTypes["default"].shape({
  code: _propTypes["default"].string,
  countries: _propTypes["default"].arrayOf(_propTypes["default"].string),
  currency: _propTypes["default"].string,
  precision: _propTypes["default"].number,
  format: _propTypes["default"].string,
  number: _propTypes["default"].string,
  symbol: _propTypes["default"].string
});
Price.propTypes = {
  value: _propTypes["default"].number.isRequired,
  currency: PropTypesCurrencyShape
};